import { LogoutRoute } from "@pages/logout/route";
import { NoSidebarLayoutDashboardRoute } from "@pages/dashboard/route";
import { createBrowserRouter } from "react-router-dom";
import { createElement } from "react";
import { ProtectedLayout } from "@components/ui/layout/ProtectedLayout";
import HomeRoute from "@pages/home/route";
import LoginRoute from "@pages/login/route";
import OfferRoute, { OfferPublicRoute } from "@pages/offer/route";
import ProfileRoute from "@pages/profile/route";
import DashboardRoute from "@pages/dashboard/route";
import SidebarLayout from "@components/ui/layout/SidebarLayout";
import AssesmentRoute from "@pages/assesment/route";
import OfferApplicantRoute from "@pages/offer-applicant/route";
import TechnicalAssessmentRoute from "@pages/technical-assesment/route";

const router = createBrowserRouter([
    ...LoginRoute,
    ...LogoutRoute,
    ...AssesmentRoute,
    ...OfferApplicantRoute,
    ...TechnicalAssessmentRoute,
    ...OfferPublicRoute,
    {
        element: createElement(ProtectedLayout),
        children: [
            {
                element: createElement(SidebarLayout),
                children: [
                    ...HomeRoute,
                    ...ProfileRoute,
                    ...OfferRoute,
                    ...DashboardRoute
                ]
            },
            ...NoSidebarLayoutDashboardRoute
        ]
    }
]);

export default router;